
import { useState, useEffect } from "react";
import { assetUrl } from "../utils/api";

export default function MatchResult() {
  // 模拟用户数据（后面可以换成后端）

  const [users, setUsers] = useState([]);
  const [index, setIndex] = useState(0);
  const [liked, setLiked] = useState([]);
  const [isVIP, setIsVIP] = useState(false);

  useEffect(() => {
  const myProfile = JSON.parse(localStorage.getItem("profile"));

  const mockUsers = [
    {
      name: "小雨",
      age: 26,
      city: "上海",
      desc: "温柔型女生，喜欢稳定关系",
      avatar: "https://randomuser.me/api/portraits/women/1.jpg",
    },
    {
      name: "阿杰",
      age: 29,
      city: "北京",
      desc: "成熟稳重，事业型男生",
      avatar: "https://randomuser.me/api/portraits/men/2.jpg",
    },
  ];

  if (myProfile) {
    const me = {
      name: myProfile.name || "我",
      age: myProfile.age || "未知",
      city: myProfile.city || "未知",
      desc: myProfile.bio || "这个人很神秘",
      avatar: myProfile.avatar || "https://via.placeholder.com/300",
    };

    setUsers([me, ...mockUsers]);
  } else {
    setUsers(mockUsers);
  }
}, []);


  const current = users[index];

  const handleLike = () => {
    setLiked([...liked, current]);
    next();
  };

  const handleDislike = () => {
    next();
  };

  const next = () => {
    if (index < users.length - 1) {
      setIndex(index + 1);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 flex flex-col items-center justify-center p-6">

      <h2 className="text-2xl font-bold mb-6">为你推荐的匹配对象</h2>

      {index === 0 && (
  <p className="text-sm text-gray-500 text-center mb-2">
    👆 这是你的资料展示效果
  </p>
)}

      {/* 卡片 */}
      {current ? (
        <div className="bg-white w-80 rounded-2xl shadow-xl overflow-hidden">

          <img
            src={assetUrl(current.avatar) || current.avatar}
            alt=""
            className="w-full h-72 object-cover"
          />

          <div className="p-4 text-left">
            <h3 className="text-xl font-bold">
              {current.name}，{current.age}
            </h3>
            <p className="text-sm text-gray-500">{current.city}</p>
            <p className="mt-2 text-gray-700 text-sm">{current.desc}</p>
          </div>

          {/* 操作按钮 */}
          <div className="flex justify-around p-4 border-t">
            <button
              onClick={handleDislike}
              className="px-6 py-2 rounded-full border text-gray-500 hover:bg-gray-100"
            >
              ❌ 跳过
            </button>

            <button
              onClick={handleLike}
              className="px-6 py-2 rounded-full bg-pink-500 text-white hover:bg-pink-600"
            >
              ❤️ 喜欢
            </button>
          </div>
        </div>
      ) : (
        <p>暂无更多推荐</p>
      )}

      {/* 💰 VIP限制 */}
      <div className="mt-6 text-center">
        {!isVIP && liked.length >= 2 && (
          <div className="bg-white p-4 rounded-xl shadow">
            <p className="mb-2 text-sm text-gray-600">
              今日免费次数已用完
            </p>
            <button
              onClick={() => setIsVIP(true)}
              className="bg-pink-500 text-white px-6 py-2 rounded-full"
            >
              开通会员 ¥29/月
            </button>
          </div>
        )}
      </div>

    </div>
  );
}

